import React, { useState } from 'react';
import DatePicker from '../../../../common/inputs/DatePicker/DatePicker';
import { Button, Grid, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Busy from "../../../../Busy";
import { requestMarkManualPaymentInvoiceAsPaid } from "../../../request/invoiceRequests";
import { CallbackActions } from "../../../../../util/ActionUtils";
import {getErrorMessage} from "../../../../../util/NetworkErrorUtil";
import moment, { Moment } from 'moment';

interface MarkInvoiceAsPaidModalProps {
  invoice: { transactionId: string; transactionNumber: string | number };
  open: boolean;
  onInvoiceAction: (callbackAction?: string, invoice?: { transactionId: string }, message?: string) => void;
  onClose: (callbackAction?: string, invoice?: { transactionId: string }, message?: string) => void;
}

const MarkInvoiceAsPaidModal = (props: MarkInvoiceAsPaidModalProps) => {

  const { invoice, open, onInvoiceAction, onClose } = props;

  const [datePaid, setDatePaid] = useState<Moment | null>(moment());

  const handleClose = () => {
    onClose();
  };

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const successUpdateInvoice = () => {
      Busy.set(false);
      onClose(CallbackActions.SUCCESS, invoice, `Successfully marked invoice ${invoice.transactionNumber} as paid.`);
    };
    const failUpdateInvoice = (error: unknown) => {
      Busy.set(false);
      onInvoiceAction(CallbackActions.ERROR, invoice, getErrorMessage(error));
    };

    Busy.set(true);
    // DatePicker can emit null if cleared; the request previously received it unchanged
    requestMarkManualPaymentInvoiceAsPaid(invoice.transactionId, datePaid as Moment, successUpdateInvoice, failUpdateInvoice);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        component: 'form',
        onSubmit
      }}
    >
      <DialogTitle>
        Record a Payment Made for this Charge
      </DialogTitle>
      <DialogContent>
        <DatePicker
          label='Payment Date'
          value={datePaid}
          onChange={setDatePaid}
        />
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent={"center"}>
          <Button variant="text" onClick={handleClose} >CANCEL</Button>
          <Button variant="contained" type="submit" >MARK AS PAID</Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
export default MarkInvoiceAsPaidModal;
